import * as React from 'react'

export function ArchetypesCeilingSquare(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M23.802 18.23l-7.17 2.654a1.798 1.798 0 01-1.264 0l-7.17-2.654c-.266-.1-.263-.51.004-.603l7.195-2.516a1.799 1.799 0 011.207 0l7.194 2.516c.268.094.271.504.004.603m3.669-4.971l-10.84-4.141a1.75 1.75 0 00-1.262 0L4.53 13.258c-.316.12-.53.476-.53.877v3.713c0 .402.214.756.53.876l10.839 4.159c.41.157.853.157 1.262 0l10.84-4.16c.315-.12.529-.473.529-.875v-3.713c0-.401-.214-.756-.529-.876'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
